import { DeliveryLog } from "@/types";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useDeliveryLogs = (
  projectId: string,
  notificationId: string,
  deliveryId: string,
  options: Omit<UseSuspensePaginatedQueryOptions<DeliveryLog>, "queryKey" | "url"> = {},
) => {
  return useSuspensePaginatedQuery<DeliveryLog>({
    queryKey: ["projects", projectId, "notifications", notificationId, "deliveries", deliveryId, "logs"],
    url: `/projects/${projectId}/notifications/${notificationId}/deliveries/${deliveryId}/logs`,
    ...options
  });
};
